import React from 'react';
import classNames from 'classnames';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { removeKeysStorage } from '../../../Common';

interface SideNavItemProps extends RouteComponentProps {
  className?: string;
  to: string;
  children: React.ReactNode;
  activePaths?: string[];
  onclick?: (e: React.MouseEvent<HTMLElement>) => void;
}

const SideNavItem: React.FC<SideNavItemProps> = ({ to, children, className, activePaths = [], location: { pathname }, onclick }) => {
  return (
    <li
      className={classNames(
        'uc-sidenav__nav-item',
        (pathname === to || activePaths.includes(pathname)) && 'uc-sidenav__nav-item--active',
        className
      )}>
      <Link
        to={to}
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          onclick && onclick(e);
          removeKeysStorage();
        }}
        data-testid-e2e={`sideNavItem-link`}>
        {children}
      </Link>
    </li>
  );
};

export default withRouter(SideNavItem);
